import Mockman from "mockman-js";
function MockMan() {
  return (
    <div className="MockAPI">
      <Mockman />
    </div>
  );
}

export default MockMan;